import { TokenDto } from '../../../interfaces/Token.dto';

export function* writeTokenToLocalStorage(token: TokenDto) {
  window.localStorage.setItem('token', JSON.stringify(token));
}

export function* removeTokenFromLocalStorage() {
  window.localStorage.removeItem('token');
}
